export function getData(url: string, wrapper?: any) {
  return fetchJSONData(url).then((data) => {
    if (wrapper) {
      return {
        ...wrapper,
        data: data,
      }
    } else {
      return data
    }
  })
}

export function fetchJSONData(url: string) {
  return fetch(url).then((response) => {
    return response.json()
  })
}

export function fetchTextData(url: string) {
  return fetch(url).then((response) => {
    return response.text()
  })
}
